// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".src-components-ImplicationBlock-ImplicationBlock__implicationWrapper--2hNpz{display:flex;width:36rem;margin-left:2rem;position:absolute;vertical-align:top;height:100%;transform:translateZ(0);z-index:1;cursor:pointer}.src-components-ImplicationBlock-ImplicationBlock__implication--2V7V5{width:36rem;overflow:hidden}.src-components-ImplicationBlock-ImplicationBlock__implicationFill--3PAiZ{position:absolute;top:2rem;bottom:2rem;left:0;right:0}", ""]);
// Exports
exports.locals = {
	"implicationWrapper": "src-components-ImplicationBlock-ImplicationBlock__implicationWrapper--2hNpz",
	"implication": "src-components-ImplicationBlock-ImplicationBlock__implication--2V7V5",
	"implicationFill": "src-components-ImplicationBlock-ImplicationBlock__implicationFill--3PAiZ"
};
module.exports = exports;
